import React from "react";

import { Illustration as StoreblocksIllustration } from "@storeblocks/icon";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useBrandingTheme } from "Store/partners/partnerHooks";
import { isDefined } from "Utils/functions";
import { getIllustration } from "./illustration.helpers";
import { IllustrationContainer } from "./illustration.styles";

interface IllustrationProps {
  readonly productBackendName: ProductBackendName;
}

export const Illustration = ({
  productBackendName,
}: IllustrationProps): React.ReactElement | null => {
  const theme = useBrandingTheme();
  const illustration = getIllustration(productBackendName);

  if (!theme.showIllustration || !isDefined(illustration)) {
    return null;
  }

  return (
    <IllustrationContainer>
      <StoreblocksIllustration name={illustration} />
    </IllustrationContainer>
  );
};
